<div class="payment-option">
  <div class="payment-option-header flex-between-center width-100p p-3">
    <p class="m-0 font-bold">Payment Details</p>
    <i class="fal fa-times close-icon" (click)="closeDialog()"></i>
  </div>

  <div class="payment-option-body p-3">
    <div class="payment-type-wrapper">
      <div class="payment-type-info">
        <div class="payment-type-icon font-20 font-gray-65">
          <i class="fal {{ icon }}"></i>
        </div>
        <div class="payment-type font-600 font-secondary-700 font-18 text-capitalize">
          {{ payment.paymentType === 'card' && payment.cardType ? payment.cardType : payment.paymentType }} {{ payment.card4Digits || '' }}
          <div *ngIf="payment?.isOnline" class="payment-date font-13 font-gray-45 font-500">
            Card - Online
          </div>
          <div *ngIf="payment?.isCardSwipe" class="payment-date font-13 font-gray-45 font-500">
            Card - Swipe
          </div>
          <div *ngIf="payment.isOnline" class="payment-date font-13 font-gray-45 font-500">Confirmation # {{ payment?.cardConfNo }}</div>
          <div class="payment-date font-13 font-gray-45 font-500">
            {{ payment.createdAt | date: 'MMM d, yyyy' }}
          </div>
        </div>
      </div>
      <div class="payment-amount font-secondary-700 font-18">
        <span class="font-600">{{ refundAmout | currency: usd }}</span>
      </div>
    </div>

    <!-- Payment action options -->
    <div class="payment-action-wrapper">
      <div [hidden]="this.payment.isOnline || payment?.isCardSwipe" (click)="openPaymentEditDialog(payment._id)" class="payment-action-box edit" [ngStyle]="{ width: isPurchased ? '380px' : '180px' }">
        <div class="payment-action-vertical">
          <i class="fal fa-pencil"></i>
          <span>
            Edit payment
          </span>
        </div>
      </div>

      <!-- Payment -->
      <div *ngIf="this.payment.isOnline || payment?.isCardSwipe" (click)="openViewPaymentDialog(payment._id)" class="payment-action-box edit">
        <div class="payment-action-vertical">
          <i class="fal fa-dollar-sign"></i>
          <span>
            View payment
          </span>
        </div>
      </div>

      <div *ngIf="!isLoading && !isPurchased" class="payment-action-box refund" [ngClass]="{ 'disabled-refund': !refundAmout }">
        <div class="payment-action-vertical" (click)="!isLoadingCheckStatus && refundAmout ? openCreateRefundDialog(payment._id) : ''">
          <i *ngIf="!isLoadingCheckStatus" class="fal fa-undo"></i>
          <i *ngIf="isLoadingCheckStatus" class="fal fa-spinner rotate"></i>
          <span>{{ payment?.isOnline || payment?.isCardSwipe ? 'Void /' : '' }} Refund payment</span>
        </div>
      </div>
    </div>

    <!-- view payment only -->
  </div>

  <div class="payment-option-footer flex-between-center width-100p pt-2 pb-2 pl-2 pr-3">
    <button id="close-dialog" class="btn btn-save font-14 font-bold pointer"
    (click)="closeDialog()" type="button">Close</button>
  </div>
</div>
